module.exports = "/_next/static/media/62b608544dcdecb57f70461aa202dcae.svg";